import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { Observable, filter, map, pipe } from 'rxjs';

import { Pipe, PipeTransform } from '@angular/core';

import { GetAvailablePrintsConfigGQL } from '../../product-editor/graphql';

@Pipe({
  name: 'printFormatLabel',
  standalone: false,
})
export class PrintFormatLabelPipe implements PipeTransform {
  constructor(private availableFormats: GetAvailablePrintsConfigGQL) {}

  transform(printFormatId: string, ...args: unknown[]): Observable<string> {
    return this.availableFormats.watch({}).valueChanges.pipe(
      throwOnQueryError,
      filter(hasCompleteQueryData),
      map((result) => result.data['availablePrintConfigs']['formats']),
      map(
        (formats) =>
          formats.find(
            (printFormat) => printFormat.printFormatId === printFormatId,
          )?.label,
      ),
    );
  }
}
